import React from 'react'

interface IHomeMenuCardProps {
    icon: React.ReactElement;
    title: string;
    onClick?: () => void;
}
const HomeMenuCard = ({ icon, title, onClick }: IHomeMenuCardProps) => {
    return (
        <div onClick={onClick} className='p-4 flex flex-col items-center justify-center cursor-pointer'>
            <div className='primaryColorLight'>
                {icon}
            </div>
            <div className=' primaryColorLight opacity-80 text-center text-[0.7rem] text-nowrap mt-2'>
                {title}
            </div>

        </div>
    )
}

export default HomeMenuCard